import { useState } from 'react';
import { createContainer } from '../utils/unstated';

export const WalletRequest = createContainer(() => {
  const [requestRejected, setRequestRejected] = useState(false);

  return {
    requestRejected,
    setRequestRejected,
  };
});

export function useWalletRequest() {
  return WalletRequest.useContainer();
}
